import { ObservableArray, View } from "binder"
import { RequestsViewModel, StatusEnum, singleRequest } from "./requests-viewModel"

export class RequestsView extends View<RequestsViewModel>{
    GetViewUniqueId(): string {
        return "V-C3841B8E-B98C-4433-AC50-C274C1848E2C"
    }
    loadHtml(): string {
        let element = require('./requests.html').default;
        let style = require('./requests.less');
        return element;
    }
    constructor() {
       super();
    }

    public set statusEnumProvider(v: StatusEnum) { this._statusEnumProvider = v; } public get statusEnumProvider(): StatusEnum { return this._statusEnumProvider;} private _statusEnumProvider: StatusEnum;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
    public set items(v: ObservableArray<singleRequest>) { this._items = v; } public get items(): ObservableArray<singleRequest> { return this._items;} private _items: ObservableArray<singleRequest>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;

}
